import React, { Component } from "react";

import ManagedCustomerList from "../Customer/ManagedCustomerList";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import NativeSelect from '@material-ui/core/NativeSelect';
import Button from '@material-ui/core/Button';

class UserForm extends Component {
	constructor(props) {
		super(props);
		this.state={
			customerId: this.props.customerId,
			username: this.props.user.username,
			fullname: this.props.user.firstName,
			email: this.props.user.email,
			enabled: this.props.user.enabled,
			projectManager: this.props.user.projectManager,
			role: this.props.user.role,
			password: "",
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handlecheckbox = this.handlecheckbox.bind(this);
		this.renderEnabled = this.renderEnabled.bind(this);
		this.handleManagedCustomers = this.handleManagedCustomers.bind(this);
		this.renderRole = this.renderRole.bind(this);
		this.handleChangeRole = this.handleChangeRole.bind(this);
	}
	
	handleChange(e) {
		e.preventDefault();
		this.setState({[e.target.name]: e.target.value });
	}

	handlecheckbox(e){
		//console.log('handlecheckbox ['+e.target.value+'] ]: '+e.target.checked);
		this.setState({ enabled: e.target.checked });
	}
	
	handleManagedCustomers(managedCustomers){
		//console.log(managedCustomers);
		this.setState({ projectManager: managedCustomers.toString() });
		//let user = this.props.user;
		//user.managedCustomers = managedCustomers;
		//this.props.saveUser(user, "");
	}
	
	handleSubmit(e) {
//		console.log("submit");
		e.preventDefault();
		let user = this.props.user;
		if(this.props.loggedUser.role==='ADMIN'){
			user.username=this.state.username;
			user.firstName=this.state.fullname;
			if(this.props.customerId>0){
				user.customer=this.state.customerId;
			}
			user.email=(typeof this.state.email!=='undefined') ? this.state.email.split("\n").map(x => x.trim()).join(",") : "";
			user.enabled=this.state.enabled;
			user.role=this.state.role;
		}
		this.props.saveUser(user, this.state.password.trim());
	}
	
	renderEnabled(){
		return <Grid item>
					<FormControlLabel
						control={<Checkbox checked={this.state.enabled} value={this.state.enabled} color="primary" onChange={this.handlecheckbox}/>}
						label="Enabled"
					/>
				</Grid>
	}
	renderUsername(){
		
		return <Grid item>
					<TextField
						disabled={disabled}
						id="username"
						name="username"
						label="Username: "
						defaultValue={this.props.user.username}
						margin="normal"
						onChange={this.handleChange}
					/>
				</Grid>
	}
	
	handleChangeRole(e){
		e.preventDefault();
		const {name, value} = e.target;
		this.setState({role: value });
	}
	
	renderRole(){
		if(this.props.user.id===0){
			const roleList = [];
			roleList.push(<option value='ADMIN'>ADMIN</option>);
			roleList.push(<option value='TRANSLATOR'>TRANSLATOR</option>);
			roleList.push(<option value='CUSTOMER'>CUSTOMER</option>);
			roleList.push(<option value='CONCURSOR'>CONCURSOR</option>);
			roleList.push(<option value='PROJECT_MANAGER'>PROJECT_MANAGER</option>);
			let roleSelect = <Grid item><NativeSelect
										value={this.state.role}
										onChange={this.handleChangeRole}>
											{roleList}
										</NativeSelect></Grid>
			return(roleSelect);
		}else{
			return('ROLE: '+this.props.user.role);
		}
	}
	
	render() {
//		console.log("Curriculum:");
//		console.log(this.props);
//		console.log("UserForm state: "+JSON.stringify(this.state));
		let save="";
		let extraInfo = "";
		let isAdmin=this.props.loggedUser.role==='ADMIN';
		let managedCustomersList = "";
		
		save =	<Grid item>
					<Button variant="contained" color="primary" aria-label="Save" onClick={this.handleSubmit.bind(this)}>
						Save
					</Button>
				</Grid>;

		let infoOdoo = this.props.user.idOdoo>0 ? <Grid item>Odoo [{this.props.user.idOdoo}]: {this.props.user.firstName}</Grid> : <Grid item></Grid>;
		if(isAdmin && this.props.user.role=='CUSTOMER' && this.state.customerId>0){
			extraInfo = <Grid item>
							Customer: {this.props.customers[this.state.customerId].name}
						</Grid>
		}
		let mails="";
		if(typeof this.props.user.email !== 'undefined'){
			//const regex = /,/g;
			mails=this.props.user.email.split(",").map(x => x.trim()).join("\n");
		}
		//console.log(this.state.projectManager);
		if(this.props.user.role==='PROJECT_MANAGER'){
			//let managedIds = this.props.user.projectManager.split(",");
			let managedIds = this.state.projectManager.split(",");
			let managedCustomers = [];
			//if(this.props.user.projectManager.length>0){
			if(this.state.projectManager.length>0){
				managedIds.forEach(id => managedCustomers.push(this.props.customers[parseInt(id, 10)]));
			}
			managedCustomersList=<ManagedCustomerList	userId={this.props.user.id}
														handleManagedCustomers={this.handleManagedCustomers}
														customers={managedCustomers}
														allCustomers={this.props.customers}/>;
		}
		//console.log(mails);
		return (
		<div class="contentM">
			<form 
				action={this.props.action}
				method={this.props.method}
				onSubmit={this.onSubmit}
			>
			<h1 className="title">USER</h1>
			<Grid container direction="column" alignItems="stretch" justify="flex-start" spacing={2}>
				{this.props.loggedUser.role==='ADMIN' && infoOdoo}
				<Grid item>
					{this.renderRole()}
				</Grid>
				{this.props.user.role=='ADMIN' && this.renderEnabled()}
				<Grid item>
					<TextField
						disabled={!isAdmin}
						id="fullname"
						name="fullname"
						label="Full Name: "
						defaultValue={this.props.user.firstName}
						margin="normal"
						onChange={this.handleChange}
					/>
				</Grid>
				<Grid item>
					<TextField
						disabled={!isAdmin}
						id="username"
						name="username"
						label="Username: "
						defaultValue={this.props.user.username}
						margin="normal"
						onChange={this.handleChange}
					/>
				</Grid>
				<Grid container item direction="row" alignItems="flex-start" justify="flex-start" spacing={0} xs={12} md={7} lg={5} xl={4}>
					<TextField
						disabled={!isAdmin}
						id="email"
						name="email"
						label="Email: "
						defaultValue={mails}
						margin="normal"
						multiline
						fullWidth
						rows={1}
						rowsMax={15}
						onChange={this.handleChange}
					/>
				</Grid>
				<Grid item>
					<TextField
						id="password"
						name="password"
						label="Password: "
						defaultValue=""
						margin="normal"
						onChange={this.handleChange}
					/>
				</Grid>
				{extraInfo}
				<Grid item>
				{save}
				</Grid>
				<Grid item>
				{managedCustomersList}
				</Grid>
			</Grid>
			</form>
		</div>
		);
	}
}

export default UserForm;